import AddBtn from '../../components/common/AddBtn';
import DataTable from '../../components/common/DataTable';
import Pagination from '../../components/common/Pagination';

import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
  SIDEBAR_OPTIONS,
  inputFields,
  view_all_table,
} from '../../shared/enums/activitystatuss_enum';
import {
  useAllActivitystatuss,
  useGetDropdownOptions,
} from '../../shared/hooks/UseActivitystatus';
import CompactSidebarFilter from '../../utils/Compact-Sidebar-Filter';
import TableSection from '../../utils/table-section';
const AllActivitystatuss = ({}) => {
  const [data, setPageNumber, deleteBtnClicked] = useAllActivitystatuss();
  const {
    activitystatuss_loading,
    activitystatuss,
    total_activitystatuss,
    page,
    pages,
  } = data;
  const [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ] = useGetDropdownOptions();
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "client") {
    //   await setClientSearchField("name");
    //   await setClientSearchValue(inputValue);
    //   callback(dropdownOptions.client);
    // }
  };
  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE}
        />

        <TableSection
          SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
          dropdownOptions={dropdownOptions}
          loadOptions={loadOptions}
          total_data={total_activitystatuss}
          data={activitystatuss}
          data_loading={activitystatuss_loading}
          page={page}
          pages={pages}
          setPageNumber={setPageNumber}
          deleteBtnClicked={deleteBtnClicked}
          view_all_table={view_all_table}
          inputFields={inputFields}
          PAGE_TITLE={PAGE_TITLE}
          PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
          LINK_URL={LINK_URL}
          DataTable={DataTable}
          TABLE_TITLE='Activity Status Management'
        />
      </div>
    </div>
  );
};

export default AllActivitystatuss;
